import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';


function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}
const emrFeatures = [
    { title: "Elevate Teleconsultation", description: "Connect with patients remotely with seamless and secure teleconsultation capabilities.", imageSrc: require("../../src/assets/images/website/product4.png") },
    { title: "Instant Patient Records Access", description: "Access comprehensive medical records instantly, allowing for faster and more informed decisions. ", imageSrc: require("../../src/assets/images/website/product3.png") },
    { title: "Specialty-Based Assessments simplified", description: "Quickly generate detailed diagnosis reports with easy-to-use assessment screens and drop-down options. ", imageSrc: require("../../src/assets/images/website/product1.png") },
    { title: "Seamless Physician Referrals", description: "Facilitate efficient referrals to specialists with just a few clicks.", imageSrc: require("../../src/assets/images/website/product5.png") }
  ];

  
  const defaultImage = require("../../src/assets/images/website/product4.png"); // Set default image
  
 

class KlinicqBenifits extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            selectedImage: defaultImage, 
            
            // selectedImages: require("../../src/assets/images/website/imagebg.png"),
      defaultImages: require("../../src/assets/images/website/product4.png"),
      telehealthFeatures: [
        { title: "Automated Follow-Up Reminders", description: "Set up patient follow-up reminders with ease, ensuring timely care and improved adherence.", imageSrc: require("../../src/assets/images/website/product1.png") },
        { title: "Enhanced Communication with Pharmacies", description: "Send prescriptions directly to pharmacies, ensuring accuracy and speed.", imageSrc: require("../../src/assets/images/website/product3.png") },
        { title: "Rapid Digital Prescribing", description: "Quickly create accurate prescriptions with our user-friendly database and drop-down options.", imageSrc: require("../../src/assets/images/website/product4.png") },
        { title: "Computerized Handwritten Prescriptions", description: "Transform handwritten notes into digital prescriptions with a simple click.", imageSrc: require("../../src/assets/images/website/product5.png") },
      ],
      hoveredFeature: null
            
        }   
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }
    handleFeatureHover = (feature) => {
        this.setState({ selectedImage: feature.imageSrc }); // Change image on hover
        this.setState({ selectedImages: feature.imageSrc, hoveredFeature: feature });
  };
    
      handleFeatureLeave = () => {
        this.setState({ selectedImage: defaultImage }); // Revert back to default image
        this.setState({ selectedImages: this.state.defaultImages, hoveredFeature: null });
      };
    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
              <Helmet>
                    <title>Benefits | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Discover the benefits of KlinicQ, from increased ROI to better patient care. Our management system helps clinics reduce wait times and streamline operations." 
                    />
                </Helmet>

                <div className="">
                    {/* <section className="my-head"> */}
                        {/* <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div> */}
                    {/* </section> */}
                    <div className="">
                        {/* <div className="sidemenu ">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div> */}

                        {/* <section className="main-body hospital-profilegap "> */}
                            {/* <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            /> */}

                            {/* <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout} /> */}

                            {/* <div className="container-fluid checkout-tabs"> */}
                                {/* <IdleTimeOutModal
                                    showModal={this.state.showModal}
                                    handleClose={this.handleClose}
                                    handleLogout={this.handleLogout}
                                /> */}

                                {/* <IdleTimer
                                    ref={ref => { this.idleTimer = ref }}
                                    element={document}
                                    onActive={this.onActive}
                                    onIdle={this.onIdle}
                                    onAction={this.onAction}
                                    debounce={250}
                                    timeout={hospitaltimeout} /> */}

<div className='product-section'>
    <Headerweb/>
         <hr className='m-0' style={{ color: '#D9F4FF' }} />

    <section class="hero-section1">
      <div class="overlap-wrapper">
        <div class="overlap">
          <div class="overlap-group">
            <div class="ellipse" aria-hidden="true"></div>
            <div class="group">
              <div class="image-container">
                <div class="ellipse-2" aria-hidden="true"></div>
                {/* <img
                  class="frame"
                  src={require("../../src/assets/images/website/benifits star.png")}
                  alt=""
                  aria-hidden="true"
                /> */}
                <img
                  class="doctor-image"
                  src={require("../../src/assets/images/website/doctor benifits.png")}
                  alt="Smiling doctor in white coat"
                />
              </div>
            </div>
            <div class="ellipse-3" aria-hidden="true"></div>
            <div class="ellipse-4" aria-hidden="true"></div>
            <div class="ellipse-5" aria-hidden="true"></div>
            <div class="increase-revenue" aria-hidden="true">OPTIMIZE OPERATIONAL</div>
            <div class="text-wrapper" aria-hidden="true">INCREASE REVENUE</div>
            <div class="increase-revenue-2" aria-hidden="true">EXPENSES</div>
            <img class="vector" src={require("../../src/assets/images/website/diagram.png")} alt="" aria-hidden="true" />
            <img class="img" src={require("../../src/assets/images/website/Benifits8.png")} alt="" aria-hidden="true" />
          </div>
          <div class="overlap-2">
            <div class="ellipse-6" aria-hidden="true"></div>
            <div class="rectangle" aria-hidden="true"></div>
            <div class="rectangle-2" aria-hidden="true"></div>
            <div class="rectangle-3" aria-hidden="true"></div>
            <section class="content-group">
              <h1 class="main-heading">Optimize operational &amp; expenses &amp; increase revenue</h1>
              <p class="description">
                KlinicQ helps clinics run smoothly, save money, and earn more by automating appointments and offering expert care online.
              </p>
              <div class="cta-group">
                <a href="/webcontact" class="cta-button primary">
                  <span class="cta-text">BOOK A DEMO</span>
                  <img
                    class="cta-icon"
                    src={require("../../src/assets/images/website/BenifitsD.png")}
                    alt=""
                    aria-hidden="true"
                  />
                </a>
                <a href="/webcontact" class="cta-button secondary">CONTACT US</a>
              </div>
            </section>
            <img
              class="frame-3"
              src={require("../../src/assets/images/website/Ellipse 3.png")}
              alt=""
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
       
            <section className=''>
           
            {/* <div className='' id='increase_revenue' style={{ marginTop: '50px', position: 'relative' }}>
    <div className='background-image' style={{ backgroundImage: `url(${require("../../src/assets/images/website/331.jpg")})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '500px', position: 'relative' }}>
        <div className='overlay-text' style={{ position: 'absolute', left: '10%', top: '50%', transform: 'translateY(-50%)', color: '#fff' }}>
            <h1>Benefits For Doctor</h1>
            <p>Streamline Your Practice, Elevate Outcomes</p>
        </div>
    </div>
</div> */}


 {/* <div className='position-relative'>
  <div className='full-container'>
    <img src={require("../../src/assets/images/website/Hero Section 1.png")} className='full-image' alt="Smiling Doctor" />
</div> */}

          {/* <div className='row m-0 align-items-center'>
            <div className='col-lg-7 col-12 h-50 '>
              <div className='container-75 section-top slide-left'>
                <h3>KlinicQ is  a renowned clinic providing exemplary online medical treatment services.</h3>
                <div className='d-flex align-items-center scheduel-section'>
                  <div>
                    <button type='button' className='me-4' >Schedule</button>
                  </div> */}
                  {/* <div className='play-around'>
                    <FontAwesomeIcon icon={faPlay} style={{ color: '#FFF' }} beat className='icon' />
                  </div> */}
                  {/* <div className='px-3'>
                    <p className='m-0'>See Video</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-5 col-12 right-img '>
              <img src={require("../../src/assets/images/website/smiling-doctor.png")} className='w-75 pt-lg-5 pt-0 slide-right' />
            </div>
          </div> */}
     
          {/* <div className='goal-section'>
            <img src={goal} />
            <h1>100%</h1>
            <p>Sucess rate This Year</p>
          </div> */}
      
        {/* </div> */}

    <div className="container-80 mt-5">
  <div className="grid-row">
    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle">1</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract.png")} alt="Image 1" />
        </div>
      </div>
      <div className="title-description">
        <h3>Elevate Tele Consultation</h3>
        <p>Connect with patients remotely with seamless and secure tele-consultation capabilities.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle1">2</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract 2.png")} alt="Image 2" />
        </div>
      </div>
      <div className="title-description">
        <h3>Instant Patient Records Access</h3>
        <p>Access comprehensive medical records instantly, allowing for faster and more informed decisions.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle2">3</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract 1.png")} alt="Image 3" />
        </div>
      </div>
      <div className="title-description">
        <h3>Specialty-Based Assessments Simplified</h3>
        <p>Quickly generate detailed diagnosis reports with easy-to-use assessment screens and dropdown options.</p>
      </div>
    </div>
  </div>

  <div className="grid-row">
    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle">4</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract 3.png")} alt="Image 4" />
        </div>
      </div>
      <div className="title-description">
        <h3>Streamlined Billing System</h3>
        <p>Simplify financial transactions with an integrated billing system designed for healthcare.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle1">5</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract 4.png")} alt="Image 5" />
        </div>
      </div>
      <div className="title-description">
        <h3>AI-Powered Health Insights</h3>
        <p>Leverage AI-driven analytics to provide personalized health insights and treatment suggestions.</p>
      </div>
    </div>

    <div className="grid-item-group">
      <div className="grid-item">
        <div className="badge-circle2">6</div>
        <div className="image-wrapper">
          <img src={require("../../src/assets/images/website/Subtract 5.png")} alt="Image 6" />
        </div>
      </div>
      <div className="title-description">
        <h3>Secure Patient Data Management</h3>
        <p>Ensure privacy and security with encrypted medical data storage and controlled access.</p>
      </div>
    </div>
  </div>
</div>

{/* 
<div className="container-90">
    <div className="row align-items-center" style={{ marginTop: '50px' }}>
        
        <div className="col-lg-6" style={{ paddingLeft: '10%', color: '#fff' }}>
            <h1>Benefits For Patients</h1>
            <p style={{ lineHeight: '1.4' }}>Online healthcare offers convenience, allowing patients to consult doctors from home, saving time and travel costs. It provides access to specialists, ensuring quality care regardless of location. Additionally, it helps in cost savings, reducing expenses related to transportation and clinic visits while improving health monitoring through digital tools.</p>
        </div>

        <div className="col-lg-6 d-flex justify-content-center align-items-center">
            <div className="image-container" style={{ width: '500px', height: '500px', backgroundImage: `url(${require("../../src/assets/images/website/250.jpg")})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
        </div>
    </div>
</div> */}




                {/* <div className=''>
                <div className='' id='increase_productivity' style={{ marginTop: '50px' }}>
    <div className='row m-0'>
        <div className='col-12'>
            <img src={require("../../src/assets/images/website/249.jpg")} className='w-100 h-auto' alt="Increase Productivity" />
        </div>
    </div>
</div>
</div> */}

{/* <div className="container-90">
<div className="row justify-content-center text-center">
    <h1>
      Dedicated to <span className="balance-move">Doctor</span> Care with Compassion
    </h1>
    <p className='container-65'>Doctors embody both skill and compassion, ensuring that patients receive not just treatment, but genuine care. Their dedication goes beyond medicine, offering comfort, guidance, and unwavering support in times of need.</p>
  </div> */}

  {/* <div class="container11">
       
        <div class="row11">
            <div class="block">
                <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Smart Scheduling</h3>
                <p>Automated reminders to minimize no-shows.</p>
            </div>
            <div class="block">
                <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Check-In & Check-Out</h3>
                <p>Streamline patient flow with digital processes.</p>
            </div>
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Resource Utilization</h3>
                <p>Optimize resources with data-driven insights.</p>
            </div>
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Staff Scheduling</h3>
                <p>Simplify shift planning with intuitive tools.</p>
            </div>
        </div>
        <div class="row11">
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Billing & Payments</h3>
                <p>Efficient digital billing and payment processing.</p>
            </div>
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Digital Identity</h3>
                <p>Secure and accurate identification for all.</p>
            </div>
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Data Protection</h3>
                <p>Robust encryption safeguards sensitive data.</p>
            </div>
            <div class="block">
            <img src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
                <h3>Doctor-Patient Integration</h3>
                <p>Enhanced collaboration through seamless tools.</p>
            </div>
        </div>
    </div> */}
  
    {/* <div class="container11 mt-5"> */}
    {/* First Row - Four Boxes */}
    {/* <div class="row11">
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Automated Follow-Up Reminders</h3>
            <p>Set up patient follow-up reminders with ease, ensuring timely care and improved adherence.</p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Enhanced Communication with Pharmacies</h3>
            <p>Send prescriptions directly to pharmacies,ensuring accuracy and speed.</p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Rapid Digital Prescribing: Accurate and Efficient</h3>
            <p>Effortless prescription creation with accuracy minimize errors, maximize efficiency.</p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Computerized Handwritten Prescriptions</h3>
            <p>Transform handwritten notes into digital prescriptions with a simple click. </p>
        </div>
    </div> */}

    {/* Center Section - Now Integrated */}
    {/* <div class="center-section merged"> */}
        {/* <h2>Optimized Healthcare Workflow</h2>
        <p>Enhancing efficiency with cutting-edge technology solutions.</p> */}
    {/* </div> */}

    {/* Bottom Row - Four Boxes */}
    {/* <div class="row11">
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Elevate Teleconsultation</h3>
            <p>Connect with patients remotely with seamless and secure teleconsultation capabilities.</p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Instant Patient Records Access</h3>
            <p>Access comprehensive medical records instantly, allowing for faster and more informed decisions. </p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Specialty-Based Assessments simplified</h3>
            <p>Quickly generate detailed diagnosis reports with easy-to-use assessment screens and drop-down options.</p>
        </div>
        <div class="block">
            <img class="top-image" src={require("../../src/assets/images/website/Benifits8.png")} alt="Icon"/>
            <h3>Seamless Physician Referrals</h3>
            <p>Facilitate efficient referrals to specialists with just a few clicks.</p>
        </div>
    </div>
</div> */}
{/* <div className="emr-container"> */}
        {/* Left side - Two-row grid layout */}
        {/* <div className="emr-left">
          {emrFeatures.map((feature, index) => (
            <div 
              key={index} 
              className="emr-item" 
              onMouseEnter={() => this.handleFeatureHover(feature)}
              onMouseLeave={this.handleFeatureLeave}
            >
              <h3>{feature.title}</h3>
              <p className="emr-description">{feature.description}</p>
            </div>
          ))}
        </div> */}

        {/* Right side - Dynamic Background Image */}
        {/* <div className="emr-right" style={{ backgroundImage: `url(${this.state.selectedImage})` }}>
        </div>
      </div>
      <div className="row justify-content-center text-center mt-5">
<h1 className="text-center">Key Features of Teleconsultation and Medical Record Access</h1>

  </div> */}

  
   {/* <div className= "telehealth-wrapper">   
  <div className="telehealth-container"> */}
        {/* Left Side - Feature Circles */}
        {/* <div className="telehealth-left">
          {this.state.telehealthFeatures.slice(0, 2).map((feature, index) => (
            <div 
              key={index} 
              className={`telehealth-feature-item ${this.state.hoveredFeature === feature ? "expanded left" : ""}`} 
              onMouseEnter={() => this.handleFeatureHover(feature)} 
              onMouseLeave={this.handleFeatureLeave}
            >
              <h3>{feature.title}</h3>
              {this.state.hoveredFeature === feature && <p>{feature.description}</p>}
            </div>
          ))}
        </div> */}

        {/* Center Image (Always Default) */}
        {/* <div className="telehealth-center">
          <img src={this.state.selectedImages} alt="Telehealth Feature" />
        </div> */}

        {/* Right Side - Feature Circles */}
        {/* <div className="telehealth-right">
          {this.state.telehealthFeatures.slice(2).map((feature, index) => (
            <div 
              key={index} 
              className={`telehealth-feature-item1 ${this.state.hoveredFeature === feature ? "expanded right" : ""}`} 
              onMouseEnter={() => this.handleFeatureHover(feature)} 
              onMouseLeave={this.handleFeatureLeave}
            >
              <h3>{feature.title}</h3>
              {this.state.hoveredFeature === feature && <p>{feature.description}</p>}
            </div>
          ))}
        </div>
      </div>

      </div> */}
    {/* <div className="row align-items-center" style={{ padding: "30px 0" }}>
      
        <div className="col-lg-6 col-12 d-flex flex-column justify-content-between">
            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>1</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div>
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>
                Elevate Teleconsultation   
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Connect with patients remotely with seamless and secure teleconsultation capabilities.</p>

            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>2</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>Instant Patient Records Access
                    
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Access comprehensive medical records instantly, allowing for faster and more informed decisions.</p>

            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>3</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>
                Specialty-Based Assessments simplified
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Quickly generate detailed diagnosis reports with easy-to-use assessment screens and drop-down options.</p>
            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>4</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>
                Seamless Physician Referrals
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>: Facilitate efficient referrals to specialists with just a few clicks.</p>
        </div>

       
        <div className="col-lg-6 col-12" style={{ paddingLeft: "30px" }}>
            <img src={require("../../src/assets/images/website/ProductFeature10.png")} className="w-100" alt="Feature Image" />
        </div>
    </div>
</div>
<div className="container-90">
    <div className="row align-items-center" style={{ padding: "30px 0" }}>
     
        <div className="col-lg-6 col-12 text-center" style={{ paddingRight: "30px" }}>
            <img src={require("../../src/assets/images/website/ProductFeature8.png")} className="w-100" alt="Feature Image" />
        </div>

    
        <div className="col-lg-6 col-12 d-flex flex-column justify-content-between">
            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>5</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>Automated Follow-Up Reminders
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Set up patient follow-up reminders with ease, ensuring timely care and improved adherence.</p>

            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>6</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>Enhanced Communication with Pharmacies
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Send prescriptions directly to pharmacies,      ensuring accuracy and speed.</p>

            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>7</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>
                Rapid Digital Prescribing: Accurate and Efficient
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>: Quickly create accurate prescriptions with our user-friendly database and drop-down options, minimizing errors and maximizing your time</p>
            <div className="mb-4 d-flex align-items-center">
                <div className="box p-2 me-3 d-flex align-items-center justify-content-center" 
                    style={{ border: "2px solid #002147", color: "#002147", width: "50px", height: "50px", textAlign: "center", borderRadius: "5px" }}>
                    <strong>8</strong>
                </div>
                <div style={{ width: "30px", height: "2px", backgroundColor: "#002147", flexGrow: "1" }}></div> 
                <h3 className="hover-effect4" style={{ backgroundColor: "#002147", color: "#fff", padding: "10px", borderRadius: "5px", flexGrow: "3" }}>
                Computerized Handwritten Prescriptions
                </h3>
            </div>
            <p style={{ color: "black", marginLeft: "80px" }}>Transform handwritten notes into digital prescriptions with a simple click. </p>
        </div>
    </div> */}
   

{/* </div> */}
 <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img src={require("../../src/assets/images/website/Group76.webp")} className="foreground-image1" alt="Foreground" />
</div>
            </div>
          </div>
        </div>
        <div>
          </div>
              
            </section>
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
    componentDidMount = () => {
       /*  console.log(this.props.userdata.user_type);
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { }); */
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(KlinicqBenifits);